import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertFragmentLinkUI from './insertfragmentlinkui';

export default class InsertFragmentLink extends Plugin {
  static get pluginName() {
    return 'InsertFragmentLink';
  }

  static get requires() {
    return [ InsertFragmentLinkUI ];
  }
}